<app-component-header></app-component-header>

<div class="component-block">
    <div class="">
        <h2>{{ title }}</h2>
    </div>
    <nz-steps [nzCurrent]="currentStep" nzSize="medium">
        <nz-step nzTitle="Step {{num}}" *ngFor="let num of steps"></nz-step>
    </nz-steps>
    <div class="step-content">
        This is step {{currentStep + 1}} content
    </div>
    <div class="step-action">
        <button nz-button nzType="default" (click)="pre()" *ngIf="currentStep > 0">Previous</button>
        <button nz-button nzType="default" (click)="next()" *ngIf="currentStep + 1 < stepNum">Next</button>
        <button nz-button nzType="primary" (click)="done()" *ngIf="currentStep + 1 == stepNum">Submit</button>
    </div>    
</div>

<div *ngIf="isLoading" class="loading-container">
    <div class="loading-spin">
        <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
        <nz-spin nzSimple [nzSize]="'large'" [nzIndicator]="indicatorTemplate"></nz-spin>
    </div>
</div>


<app-component-footer></app-component-footer>